<!-- Informes APDS -->

<template>
  <div class="presReportF" v-if="loaded">

    <div style="display:flex;justify-content:center">
      <v-sheet :elevation="4">

        <!-- Cabecera -->
        <div class="cabecera">
          <baseHeader
            :cfg="$cfe.headers.finder"
            :titulo='$store.state[storeName].titulo'
            @onEvent="eventHeader">
          </baseHeader>
        </div>


        <!-- Botonera -->
        <div class="pt-2 pl-2">
          <baseBtraExtra class="conflex"
            :permExtra="permExtra"
            :modulo="btExtCfg"
            @onEvent="execAccion">
          </baseBtraExtra>
        </div>

        <!-- Contenido -->
        <div class="contenedor" style="width:950px">
          <div class="conflex">
            <div class="columna" style="width:32%">

              <!-- Menú -->
              <div class="cab">Tipos de Informes</div>
              <v-sheet v-bind="$cfg.styles.marco">
                <v-treeview
                  :items="recordsRead[0]"
                  item-key="d"
                  item-text="n"
                  item-children="c"
                  activatable
                  dense
                  open-on-click
                  return-object
                  @update:active="changeInf">
                </v-treeview>
              </v-sheet>
            </div>

            <div class="columna" style="width:66%;margin-left:10px">
              <div class="cab">Condiciones</div>

              <v-sheet v-bind="$cfg.styles.marco">

                <!-- Ordenado -->
                <div style="display:flex">
                    <v-select
                        v-bind="$select"
                        v-model="ct.ord[2]"
                        :label="ct.ord[1]"
                        :items="ord"
                        item-value="d"
                        item-text="n">
                    </v-select>
                </div>

                <!-- Año, Compañia -->
                <div style="display:flex">
                    <v-select
                        style="flex: 0 0 25%"
                        v-bind="$select"
                        v-model="ct.ano[2]"
                        :label="ct.ano[1]"
                        :items="recordsRead[2]"
                        item-value="d"
                        item-text="n">
                    </v-select>
                    <v-select
                        style="flex: 0 0 75%"
                        v-bind="$select"
                        v-model="ct.cia[2]"
                        :label="ct.cia[1]"
                        :items="recordsRead[3]"
                        item-value="d"
                        item-text="n"
                        :disabled="app>1">
                    </v-select>
                </div>

                <!-- Tipo, Estado -->
                <div style="display:flex">
                <v-select
                        style="flex: 0 0 60%"
                        v-bind="$select"
                        v-model="ct.tipo[2]"
                        :label="ct.tipo[1]"
                        :items="itemsTipos"
                        item-value="id"
                        item-text="name">
                    </v-select>
                    <v-select
                        style="flex: 0 0 40%"
                        v-bind="$select"
                        v-model="ct.estado[2]"
                        :label="ct.estado[1]"
                        :items="recordsRead[4]"
                        item-value="d"
                        item-text="n">
                    </v-select>
                </div>

                <!-- Grupo, Central -->
                <div style="display:flex">
                    <v-select
                        style="flex: 0 0 40%"
                        v-bind="$select"
                        v-model="ct.grupo[2]"
                        :label="ct.grupo[1]"
                        :items="recordsRead[6]"
                        item-value="d"
                        item-text="n"
                        multiple>
                        <template v-slot:selection="{ index }">
                            <span
                            v-if="index=== 0"
                            class="grey--text caption">
                                ({{ ct.grupo[2].length }} grupo/s seleccionado/s)
                            </span>
                        </template>
                    </v-select>
                    <ctrlF style="flex: 0 0 60%" :ct="ct.central"></ctrlF>
                </div>

                <!-- Funeraria -->
                <div style="display:flex">
                    <ctrlF style="flex: 0 0 100%" :ct="ct.fune"></ctrlF>
                </div>

                <!-- Origen / Lugar -->
                <div style="display:flex">
                    <uiMultiple
                      style="flex: 0 0 100%"
                      :ctrl="ct.origen"
                      :ct="ct"
                      @change="changeCta">
                    </uiMultiple>
                </div>
                <!-- <div style="display:flex">
                    <v-select
                        style="flex: 0 0 30%"
                        v-bind="$select"
                        v-model="ct.origen[2]"
                        :label="ct.origen[1]"
                        :items="recordsRead[5]"
                        item-value="d"
                        item-text="n">
                    </v-select>
                    <ctrlF style="flex: 0 0 70%" :ct="ct.lugar"></ctrlF>
                </div> -->

                <!-- Situacion, Referencia Cia -->
                <div style="display:flex">
                    <uiText
                        :label="ct.situ[1]"
                        v-model="ct.situ[2]">
                    </uiText>
                    <uiText
                        :label="ct.refcia[1]"
                        v-model="ct.refcia[2]">
                    </uiText>
                </div>

                <!-- Jefe Zona, Centro Tramitador -->
                <div style="display:flex">
                    <v-select
                        style="flex: 0 0 60%"
                        v-bind="$select"
                        v-model="ct.zona[2]"
                        :label="ct.zona[1]"
                        :items="itemsZonas"
                        item-value="id"
                        item-text="name"
                        :disabled="zona>0">
                    </v-select>
                    <v-select
                        style="flex: 0 0 40%"
                        v-bind="$select"
                        v-model="ct.centro[2]"
                        :label="ct.centro[1]"
                        :items="itemsCentros"
                        item-value="id"
                        item-text="name"
                        :disabled="zona>0">
                    </v-select>
                </div>

              </v-sheet>
            </div>
          </div>
        </div>
      </v-sheet>
    </div>
  </div>
</template>


<script>

  import { mixR } from "@/mixins/mixR.js";
  import baseHeader from "@/base/baseHeader";
  import baseBtraExtra from "@/base/baseBtraExtra";

  export default {
    mixins: [mixR],
    components: { baseHeader, baseBtraExtra },
    props: {},

    data() {
      return {
        stIni: {
          api: "presR",
          titulo:"·Informe PRESUPUESTOS",
          name:"presR",
          mView:'',
          pView:[]
        },

        ord: [],
        itemsTipos:[],
        itemsZonas:[],
        itemsCentros:[]

      };
    },



    methods: {
        iniDataParticular() {
            console.log("DEV " + this.stIni.api + " ********************** (iniDataParticular)");

            this.btExtCfg.btnsAccion= [
              { accion:'verPdf', btn:"pdf" },
              { accion:'verExcel', btn:"excel" }
            ];

            // año y cia
            this.ct.ano[2]=new Date().getFullYear();
            this.ct.cia[2]='1';

            // tipos presupuestos
            this.itemsTipos= this.$store.state.datos_iniciales.tipo_presup.slice();
            this.itemsTipos.unshift({id:'0',name:'( Selecciona Tipo )'});

            // cos (jefes de zona)
            this.itemsZonas= this.$store.state.datos_iniciales.zonas.slice();
            this.itemsZonas.unshift({id:'0',name:'( Selecciona )'});
            // si app=2=apds
            if (this.app==2 && this.zona>0) this.ct.zona[2]=this.zona;

            //centros
            this.itemsCentros= this.$store.state.datos_iniciales.ct.slice();
            this.itemsCentros.unshift({id:'0',name:'( Centro Tramitador )'});

            // origen presupuesto
            this.ct.tipo_origen[2]=1;

        },

        // si cambia cuenta en uimulti
        changeCta(evt) {
            console.log('changeCta',evt);
            //if (!evt[4].comp) return;
        },


      //verPdf,verExcel,showReport en mixR

    }
  };
</script>
